import contentWithDrawer from "../components/contentWithDrawer";
import DrawerContent from "../components/CompareRuns/CompareRunsDrawerContent";
import MainContent from "../components/CompareRuns/CompareRunsMainContent";

const CompareRuns = contentWithDrawer(MainContent, DrawerContent);

export default CompareRuns;
